import { useProductStore } from "./useProductStore";

export const useCurrentProduct = () =>
  useProductStore((state) => state.product);
